import {
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
} from '@heroicons/react/20/solid';

export function getSkusAndQuantitiesFromLines(lines) {
  const cartObject = {};
  lines.forEach((line) => {
    if (cartObject[line.merchandise.sku]) {
      cartObject[line.merchandise.sku] += line.quantity;
    } else {
      cartObject[line.merchandise.sku] = line.quantity;
    }
  });
  return cartObject;
}

export function addOrdinalToNumber(n: number): string {
  const result =
    n +
    {e: 'st', o: 'nd', w: 'rd', h: 'th'}[
      new Intl.PluralRules('en', {type: 'ordinal'}).select(n)[2]
    ];

  return result;
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export function availabilityIcon(textAvailability: string) {
  switch (textAvailability) {
    case 'AVAILABLE':
      return <CheckCircleIcon className="h-6 w-6 text-blue-500 mx-auto" />;
      break;
    case 'UNAVAILABLE':
      return <XCircleIcon className="h-6 w-6 text-red-500 mx-auto" />;
      break;
    case 'LOW':
      return <ClockIcon className="h-6 w-6 text-yellow-500 mx-auto" />;
      break;
    default:
      return <XCircleIcon className="h-6 w-6 text-red-500 mx-auto" />;
      break;
  }
}

export function binaryAvailabilityIcon(available: boolean) {
  if (available) {
    return (
      <CheckCircleIcon className="h-4 w-4 md:h-6 md:w-6 text-blue-500 mx-auto" />
    );
  } else {
    return (
      <XCircleIcon className="h-4 w-4 md:h-6 md:w-6 text-red-500 mx-auto" />
    );
  }
}

export function shortDate(isoString: string): string {
  const date = new Date(`${isoString} 12:00:00`);
  return `${date.toLocaleString('default', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })}`;
}

export function abbreviatedDate(isoString: string): string {
  const date = new Date(`${isoString} 12:00:00`);
  return `${date.toLocaleString('default', {
    month: 'short',
    day: 'numeric',
  })}`;
}

export function textDate(isoString: string): string {
  const date = new Date(`${isoString} 12:00:00`);

  const dayOfWeek = date.toLocaleDateString('en-US', {
    weekday: 'long',
    timeZone: 'America/Chicago',
  });

  const textDate = date.toLocaleDateString('en-US', {
    month: 'long',
    timeZone: 'America/Chicago',
  });

  const digitDay = date.toLocaleDateString('en-US', {
    day: 'numeric',
    timeZone: 'America/Chicago',
  });

  const withOrdinal = addOrdinalToNumber(parseInt(digitDay));

  return `${dayOfWeek}, ${textDate} ${withOrdinal}`;
}

export function estimatedArrivalDate(isoString: string): string {
  const date = new Date(`${isoString} 12:00:00`);

  date.setDate(date.getDate() + 3);

  const dayOfWeek = date.toLocaleDateString('en-US', {
    weekday: 'long',
    timeZone: 'America/Chicago',
  });

  const textDate = date.toLocaleDateString('en-US', {
    month: 'long',
    timeZone: 'America/Chicago',
  });

  const digitDay = date.toLocaleDateString('en-US', {
    day: 'numeric',
    timeZone: 'America/Chicago',
  });

  const withOrdinal = addOrdinalToNumber(parseInt(digitDay));

  return `${dayOfWeek}, ${textDate} ${withOrdinal}`;
}
